import { getMessages } from '../../../../../../../store/constants';

export const CUSTOM_ACTIONS = getMessages().getText('card_form_custom_section_item_actions');
export const CUSTOM_SHOW = getMessages().getText('card_form_custom_section_show');
export const CUSTOM_HIDE = getMessages().getText('card_form_custom_section_hide');
export const CUSTOM_PIN = getMessages().getText('card_form_custom_section_pin');
export const CUSTOM_UNPIN = getMessages().getText('card_form_custom_section_unpin');
